export const HANDLER_BUDGET_MS = 5_000;

export type HandlerOutcome = { ok: true; message: string } | { ok: false; message: string };

export interface FrontendCallRecord {
  toolCallId: string;
  toolName: string;
  settled: boolean;
  ok: boolean | null;
  message: string | null;
  timedOut: boolean;
}

export type FrontendOutcome =
  | { kind: "running" }
  | { kind: "shown" }
  | { kind: "unconfirmed" }
  | { kind: "refused" };

export function frontendOutcome(record: FrontendCallRecord | undefined): FrontendOutcome | null {
  if (!record) return null;
  if (!record.settled) return { kind: "running" };
  if (record.timedOut) return { kind: "unconfirmed" };
  return record.ok === true ? { kind: "shown" } : { kind: "refused" };
}

export function supersededRefusals(
  nodes: readonly { role: string; tools: readonly { toolCallId: string; toolName: string }[] }[],
  calls: ReadonlyMap<string, FrontendCallRecord> | undefined,
): ReadonlySet<string> {
  const hidden = new Set<string>();
  let refused = new Map<string, string[]>();
  for (const node of nodes) {
    if (node.role === "user") refused = new Map();
    for (const tool of node.tools) {
      const outcome = frontendOutcome(calls?.get(tool.toolCallId))?.kind;
      if (outcome === "refused") {
        refused.set(tool.toolName, [...(refused.get(tool.toolName) ?? []), tool.toolCallId]);
      } else if (outcome === "shown") {
        for (const id of refused.get(tool.toolName) ?? []) hidden.add(id);
        refused.delete(tool.toolName);
      }
    }
  }
  return hidden;
}

export function frontendOutcomeKey(outcome: FrontendOutcome): string {
  return outcome.kind;
}
